// client/src/components/wetakeover/CreatorSlider.jsx
import React from 'react';
import { PRICING } from './PricingPreview';

const CreatorSlider = ({ count, onCountChange, tier }) => {
  const quickSelectValues = [25, 40, 65, 100, 150];

  const calculateEstimates = (numCreators, tierType) => {
    if (!tierType) return { minImpressions: 0, maxImpressions: 0, dollarEfficiency: 0 };

    const qrtCost = PRICING[tierType].qrtCost;

    if (tierType === 'mid') {
      // Mid-tier: 500-1000 avg impressions per creator
      return {
        minImpressions: (numCreators * 500).toLocaleString(),
        maxImpressions: (numCreators * 1000).toLocaleString(),
        dollarEfficiency: ((numCreators * 750) / (numCreators * qrtCost) * 1000).toFixed(0), // 1k impressions per dollar
      };
    } else {
      // High-tier: 1500+ avg impressions per creator
      return {
        minImpressions: (numCreators * 1500).toLocaleString(),
        maxImpressions: (numCreators * 2500).toLocaleString(),
        dollarEfficiency: ((numCreators * 2000) / (numCreators * qrtCost) * 1000).toFixed(0), // 1k impressions per dollar
      };
    }
  };

  const estimates = calculateEstimates(count, tier);

  return (
    <div className="ui-motion-enter space-y-8 max-w-3xl mx-auto">
      <div className="text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-4">
          How Many <span className="text-yellow-300">Creators</span>?
        </h2>
        <p className="text-white/70 text-lg">
          Select between 1-150 creators for your campaign
        </p>
      </div>

      {/* Large Number Display */}
      <div className="text-center py-8">
        <div className="text-8xl md:text-9xl font-extrabold text-yellow-300 leading-none">
          {count}
        </div>
        <div className="text-xl text-white/50 mt-4">
          {tier ? (tier === 'mid' ? 'Mid-Tier' : 'High-Tier') : ''} Creators
        </div>
      </div>

      {/* Slider */}
      <div className="px-4 bg-white/5 border border-white/10 backdrop-blur-md rounded-3xl p-8">
        <input
          type="range"
          min="1"
          max="150"
          value={count}
          onChange={(e) => onCountChange(parseInt(e.target.value))}
          className="w-full h-3 bg-white/10 rounded-full appearance-none cursor-pointer
            [&::-webkit-slider-thumb]:appearance-none
            [&::-webkit-slider-thumb]:w-8
            [&::-webkit-slider-thumb]:h-8
            [&::-webkit-slider-thumb]:rounded-full
            [&::-webkit-slider-thumb]:bg-yellow-300
            [&::-webkit-slider-thumb]:cursor-pointer
            [&::-webkit-slider-thumb]:shadow-[0_0_20px_rgba(250,204,21,0.5)]
            [&::-webkit-slider-thumb]:transition-transform
            motion-safe:[&::-webkit-slider-thumb]:hover:scale-105
            [&::-moz-range-thumb]:w-8
            [&::-moz-range-thumb]:h-8
            [&::-moz-range-thumb]:rounded-full
            [&::-moz-range-thumb]:bg-yellow-300
            [&::-moz-range-thumb]:border-0
            [&::-moz-range-thumb]:cursor-pointer"
          style={{
            background: `linear-gradient(to right, rgb(253 224 71) 0%, rgb(253 224 71) ${(count / 150) * 100}%, rgba(255,255,255,0.1) ${(count / 150) * 100}%, rgba(255,255,255,0.1) 100%)`,
          }}
        />
        <div className="flex justify-between mt-3 text-sm text-white/50">
          <span>1</span>
          <span>75</span>
          <span>150</span>
        </div>
      </div>

      {/* Quick Select Buttons */}
      <div className="flex gap-3 justify-center flex-wrap">
        {quickSelectValues.map((preset) => (
          <button
            key={preset}
            onClick={() => onCountChange(preset)}
            className={`px-6 py-3 rounded-full font-medium transition-colors ${
              count === preset
                ? 'bg-yellow-300 text-black shadow-[0_10px_30px_rgba(250,204,21,0.3)]'
                : 'bg-white/5 text-white hover:bg-white/10 border border-white/10'
            }`}
          >
            {preset}
          </button>
        ))}
      </div>

      {/* Estimated Reach */}
      {tier && (
        <div className="bg-white/5 rounded-[32px] p-6 border border-white/10">
          <h4 className="text-lg font-semibold text-white mb-4">
            Estimated Reach ({tier === 'mid' ? 'Mid-Tier' : 'High-Tier'}):
          </h4>
          <ul className="space-y-2 text-white/60">
            <li>• Expected impressions: {estimates.minImpressions} - {estimates.maxImpressions}</li>
            <li>• Expected ~{estimates.dollarEfficiency} impressions per $1 spent</li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default CreatorSlider;
